import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";

// Retour depuis Stripe Checkout après paiement — la campagne s'active via webhook (voir
// backend), pas via cette page : ici on attend juste que le statut passe à 'active' pour
// donner une confirmation nette, plutôt que de prétendre que c'est fait avant de le savoir.
export default function SponsorSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<"waiting" | "active" | "timeout">("waiting");

  useEffect(() => {
    let attempts = 0;
    const interval = setInterval(async () => {
      attempts++;
      try {
        const data = await api.get("/sponsorships/me");
        const recent = (data?.sponsorships || [])[0];
        if (recent?.status === "active") {
          setStatus("active");
          clearInterval(interval);
        }
      } catch {}
      if (attempts >= 15) {
        setStatus(s => (s === "waiting" ? "timeout" : s));
        clearInterval(interval);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ maxWidth: 480, margin: "60px auto", padding: 24, textAlign: "center" }}>
      {status === "waiting" && (
        <>
          <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Confirmation du paiement...</h1>
          <p style={{ fontSize: 14, color: "#666" }}>On finalise l'activation de ta campagne, ça ne prend que quelques secondes.</p>
        </>
      )}
      {status === "active" && (
        <>
          <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Campagne lancée !</h1>
          <p style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>Ta sponsorisation est active et commence à toucher son audience ciblée.</p>
          <button onClick={() => navigate("/settings")} style={{ padding: "13px 24px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
            Voir mes sponsorisations
          </button>
        </>
      )}
      {status === "timeout" && (
        <>
          <div style={{ fontSize: 40, marginBottom: 16 }}>💳</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Paiement en cours de traitement</h1>
          <p style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>Ça arrive parfois, vérifie le statut depuis tes réglages dans un instant.</p>
          <button onClick={() => navigate("/settings")} style={{ padding: "13px 24px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
            Voir mes sponsorisations
          </button>
        </>
      )}
    </div>
  );
}
